/**
 * CUSTOM.JS
 * Social Proof + Existing Review Modal
 */

document.addEventListener("DOMContentLoaded", function () {

  /* =========================================================
     REVIEW MODAL (Existing – Unchanged)
  ========================================================= */

  const modal = document.getElementById("ReviewModal");

  if (modal) {
    document.querySelectorAll("[data-open-reviews]").forEach(el => {
      el.addEventListener("click", () => {
        modal.classList.add("active");
        modal.setAttribute("aria-hidden", "false");
      });
    });

    document.querySelectorAll("[data-close-reviews]").forEach(el => {
      el.addEventListener("click", () => {
        modal.classList.remove("active");
        modal.setAttribute("aria-hidden", "true");
      });
    });

    document.addEventListener("keydown", function(e){
      if(e.key === "Escape"){
        modal.classList.remove("active");
        modal.setAttribute("aria-hidden", "true");
      }
    });
  }

  /**
   * NOTE:
   * We intentionally removed the older SocialProofThemeConfig + SocialProofToastRoot engine
   * to prevent duplicate popups / conflicting logic.
   * The implementation below uses SocialProofRoot + social-proof-orders.json.
   */

});


/* =========================================================
   SOCIAL PROOF (Popup + Activity) — SocialProofRoot engine
========================================================= */
(function () {
  function toBool(v) { return String(v) === "true"; }

  function parseHandles(csv) {
    if (!csv) return [];
    return String(csv)
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  }

  // Simple deterministic hash for "activity count" (no backend)
  function hashString(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h << 5) - h + str.charCodeAt(i), h |= 0;
    return Math.abs(h);
  }

  // Expand US state abbreviations to full names for nicer "Someone from Utah, USA"
  const US_STATE_MAP = {
    AL:"Alabama", AK:"Alaska", AZ:"Arizona", AR:"Arkansas", CA:"California", CO:"Colorado", CT:"Connecticut",
    DE:"Delaware", FL:"Florida", GA:"Georgia", HI:"Hawaii", ID:"Idaho", IL:"Illinois", IN:"Indiana", IA:"Iowa",
    KS:"Kansas", KY:"Kentucky", LA:"Louisiana", ME:"Maine", MD:"Maryland", MA:"Massachusetts", MI:"Michigan",
    MN:"Minnesota", MS:"Mississippi", MO:"Missouri", MT:"Montana", NE:"Nebraska", NV:"Nevada", NH:"New Hampshire",
    NJ:"New Jersey", NM:"New Mexico", NY:"New York", NC:"North Carolina", ND:"North Dakota", OH:"Ohio", OK:"Oklahoma",
    OR:"Oregon", PA:"Pennsylvania", RI:"Rhode Island", SC:"South Carolina", SD:"South Dakota", TN:"Tennessee",
    TX:"Texas", UT:"Utah", VT:"Vermont", VA:"Virginia", WA:"Washington", WV:"West Virginia", WI:"Wisconsin", WY:"Wyoming"
  };

  function normalizeCountry(c) {
    const cc = (c || "").trim();
    if (cc === "US") return "USA";
    return cc;
  }

  function normalizeProvince(p, country) {
    const pv = (p || "").trim();
    const c = (country || "").trim();
    if (c === "US" && US_STATE_MAP[pv]) return US_STATE_MAP[pv];
    return pv;
  }

  function shouldRunForProduct(root) {
    const useAll = toBool(root.dataset.useAll);
    if (useAll) return true;

    const selected = parseHandles(root.dataset.selectedHandles);
    const current = (root.dataset.currentHandle || "").trim();
    if (!current) return false;

    return selected.includes(current);
  }

  function formatLocation(order, locationFormat) {
    const rawProvince = (order.province || "").trim();
    const rawCountry = (order.country || "").trim();

    const province = normalizeProvince(rawProvince, rawCountry);
    const country = normalizeCountry(rawCountry);

    if (locationFormat === "country_only") return country || "";
    if (province && country) return `${province}, ${country}`;
    return province || country || "";
  }

async function loadOrders(root) {
  const baseUrl = root.dataset.ordersUrl || "/assets/social-proof-orders.json";
  const res = await fetch(`${baseUrl}?v=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to load social-proof-orders.json: " + res.status);
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function applyTransitions(popup, fadeInS, fadeOutS) {
    popup.style.transition = `opacity ${fadeInS}s ease, transform ${fadeInS}s ease`;
    popup.dataset.fadeOut = String(fadeOutS);
  }

  function showPopup(popup) {
    popup.classList.add("is-visible");
    popup.setAttribute("aria-hidden", "false");
  }

  function hidePopup(popup) {
    const fadeOutS = parseFloat(popup.dataset.fadeOut || "0.5");
    popup.style.transition = `opacity ${fadeOutS}s ease, transform ${fadeOutS}s ease`;
    popup.classList.remove("is-visible");
    popup.setAttribute("aria-hidden", "true");
  }

  function insertActivityLine(root) {
    const enabled = toBool(root.dataset.activityEnabled);
    const isProduct = toBool(root.dataset.isProduct);
    if (!enabled || !isProduct) return;

    if (!shouldRunForProduct(root)) return;

    const tpl = root.dataset.activityTemplate || "This product has a lot of activity — it’s been recently viewed {{count}} times.";
    const lookback = parseInt(root.dataset.activityLookbackHours || "48", 10);
    const minCount = parseInt(root.dataset.activityMinCount || "0", 10);

    // Seed changes slowly: bucket by 1-hour windows so it doesn't jitter constantly
    const bucketHours = 1;
    const bucket = Math.floor(Date.now() / (bucketHours * 60 * 60 * 1000));

    const handle = (root.dataset.currentHandle || "product").trim();
    const seed = hashString(`${handle}|${bucket}|${lookback}`);

    // Range: minCount .. minCount+ (20..90)
    const range = 250 + (seed % 1300); // 15..134 variation
const count = Math.max(minCount, range);

    const text = tpl.replace(/\{\{\s*count\s*\}\}/g, String(count));

    // Place activity directly under the reviews row (rating stars / link)
    const reviewsRow =
      document.querySelector(".ProductMeta__Reviews") ||
      document.querySelector("[data-open-reviews]") ||
      document.querySelector("#shopify-product-reviews");

    let insertAfter = reviewsRow ||
      document.querySelector(".ProductMeta__PriceList") ||
      document.querySelector(".ProductMeta") ||
      document.querySelector(".Product__Info .Container");

    if (!insertAfter) return;

    // Avoid duplicates
    const existing = document.getElementById("SP_ActivityLine");
if (existing) {
  existing.textContent = text;
  return;
}

    const div = document.createElement("div");
    div.className = "SP_Activity";
    div.id = "SP_ActivityLine";
    div.textContent = text;

    insertAfter.insertAdjacentElement("afterend", div);
  }

  document.addEventListener("DOMContentLoaded", async function () {
    const root = document.getElementById("SocialProofRoot");
    if (!root) return;

    // Activity counter (product page) — single insertion
    insertActivityLine(root);
// Refresh activity line every 10 minutes so it doesn’t feel frozen
setInterval(() => insertActivityLine(root), 10 * 60 * 1000);
    // Purchase popup
    const enabled = toBool(root.dataset.enabled);
    if (!enabled) return;

    const isHome = toBool(root.dataset.isHome);
    const isProduct = toBool(root.dataset.isProduct);

    const runOnHome = toBool(root.dataset.onHome);
    const runOnProduct = toBool(root.dataset.onProduct);

    if ((isHome && !runOnHome) || (isProduct && !runOnProduct)) return;
    if (isProduct && !shouldRunForProduct(root)) return;

    const popup = document.getElementById("SocialProofPopup");
/* =========================
   CLICK → GO TO PRODUCT
========================= */

const productUrl = "https://www.getankrpoint.com/products/ankr-point%E2%84%A2-bow-retention-system";

popup.style.cursor = "pointer";

popup.addEventListener("click", function(e) {
  // Don't redirect if they click the close button
  if (e.target.closest("#SP_Close")) return;

  window.location.href = productUrl;
});
    // New UI elements (white card layout)
    const imgEl = document.getElementById("SP_Image");
    const headlineEl = document.getElementById("SP_Headline");
    const productEl = document.getElementById("SP_Product");
    const timeEl = document.getElementById("SP_Time");
    const closeBtn = document.getElementById("SP_Close");

    if (!popup || !imgEl || !headlineEl || !productEl || !timeEl) return;

    const intervalS = parseInt(root.dataset.intervalSeconds || "15", 10);
    const stopAfter = parseInt(root.dataset.stopAfter || "50", 10);
    const restartAfterMin = parseInt(root.dataset.restartAfterMinutes || "60", 10);
    const fadeInS = parseFloat(root.dataset.fadeInSeconds || "0.6");
    const visibleS = parseFloat(root.dataset.visibleSeconds || "5");
    const fadeOutS = parseFloat(root.dataset.fadeOutSeconds || "0.6");

    const locationFormat = root.dataset.locationFormat || "state_country";
    const purchaseLabel = root.dataset.purchaseLabel || "Purchased";
    const preorderLabel = root.dataset.preorderLabel || "Pre-Ordered";

    applyTransitions(popup, fadeInS, fadeOutS);

    let orders = [];
    try {
     orders = await loadOrders(root);
    } catch (e) {
  console.warn("Social proof orders load failed:", e);
  console.warn("ordersUrl dataset:", root?.dataset?.ordersUrl);
  return;
}

    if (!orders.length) return;
    orders = shuffle(orders).slice(0, 50);

    let idx = 0;
    let shown = 0;
    let paused = false;
    let hideTimer = null;

    function nextOrder() {
      const o = orders[idx % orders.length];
      idx++;

      const loc = formatLocation(o, locationFormat);
      const time = (o.time || "Recently").trim();
      const img = (o.image || "").trim();

      // Choose wording based on label if you ever add preorders later
      const labelRaw = (o.label || "").toLowerCase();
      const isPre = labelRaw.includes("pre");
      const verb = isPre ? "pre-ordered" : "bought";

      // Your preferred headline
      const locText = loc || "your area";
      headlineEl.textContent = `Someone from ${locText} recently ${verb}`;

      // Product line
      productEl.textContent = (o.product || "Product").trim();

      // Time line (styled via CSS)
      timeEl.textContent = time;

      // Image
      if (img) {
        imgEl.src = img;
        imgEl.alt = (o.product || "Product").trim();
        imgEl.style.display = "block";
      } else {
        imgEl.removeAttribute("src");
        imgEl.alt = "";
        imgEl.style.display = "none";
      }
    }

    function cycleOnce() {
      if (paused) return;

      if (shown >= stopAfter) {
        paused = true;
        hidePopup(popup);

        setTimeout(() => {
          shown = 0;
          paused = false;
        }, restartAfterMin * 60 * 1000);

        return;
      }

      nextOrder();
      showPopup(popup);
      shown++;

      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        hidePopup(popup);
      }, Math.max(0, visibleS) * 1000);
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        paused = true;
        hidePopup(popup);
        // optional: resume after 10 minutes
        setTimeout(() => { paused = false; }, 10 * 60 * 1000);
      });
    }

    // Initial delay so page load feels clean
    setTimeout(() => {
      cycleOnce();
      setInterval(cycleOnce, Math.max(3, intervalS) * 1000);
    }, 1500);
  });
})();